import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout Components
import Header from './components/layout/Header';
import MobileSidebar from './components/layout/MobileSidebar';
import Footer from './components/layout/Footer';
import BackToTopButton from './components/layout/BackToTopButton';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ProductPage from './pages/ProductPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <Router>
      <div className="font-sans bg-gray-50 text-gray-900 relative antialiased selection:bg-cogCyan/30">
        {/* Header stays on top of every page */}
        <Header />
        
        {/* Dynamic page content switches here */}
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/products" element={<ProductPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>

        {/* Footer and Button stay on the bottom of every page */}
        <Footer />
        <BackToTopButton />
      </div>
    </Router>
  );
}

export default App;